import { AccountingSyncStatus } from '../types'
import Api from './Api'

export default class AccountingSyncController extends Api {
	static getStatus(): Promise<AccountingSyncStatus> {
		return fetch(`/api/accounting_sync`, {
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': this.token
			},
			credentials: 'same-origin',
		})
			.then(res => res.json())
	}

	static synchronize(): Promise<{ success: boolean }> {
		return fetch(`/api/accounting_sync`, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': this.token
			},
			credentials: 'same-origin',
		})
			.then(res => res.json())
	}
}
